exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-deity-input{width:45%;text-align:center}.accordion a{text-decoration:none}.accordion .card-header{padding:1rem;color:var(--light-color);display:flex;justify-content:space-between;box-shadow:0 .4px 1.2rem rgba(0,0,0,.2)}.accordion .card-header:hover{color:var(--primary-color);text-decoration:none}.accordion .card-header h4{display:inline;text-decoration:none;margin:0;line-height:.8}.collapsed-content{background-color:var(--secondary-color-lighter);padding:1rem;z-index:-1;box-shadow:inset 0 .4rem 4px rgba(0,0,0,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28b58f35","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/klasses/Cleric.vue
// module id = 67
// module chunks = 0